module.exports = __webpack_public_path__ + "img/college-alma.bc533de6.jpg";